import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../css/about.scss";
import { Link } from "react-router-dom";

function About() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <body className=" color-scheme color-scheme--scheme-1">
      <Header />
      <main id="page-content-layer">
        <div className="policy-page">
          <div className="policy-container">
            <h1>About Mangoes</h1>
            <p className="policy-intro">
              Mangoes celebrates contemporary design with a Mediterranean
              spirit. We blend timeless silhouettes with modern craftsmanship to
              help you look and feel your best every day.
            </p>

            <section className="policy-section">
              <h2>Who We Are</h2>
              <p>
                Founded in Barcelona in 1984, Mangoes has grown into a global
                fashion house with a presence in more than 110 countries. Our
                collections are designed to be versatile, elevated, and easy to
                wear—pieces you reach for season after season.
              </p>
            </section>

            <section className="policy-section">
              <h2>Our Design Philosophy</h2>
              <ul>
                <li>
                  Effortless silhouettes inspired by Mediterranean living.
                </li>
                <li>
                  Premium fabrics and thoughtful details for lasting quality.
                </li>
                <li>
                  Collections curated to complement your lifestyle—from work to
                  weekend.
                </li>
              </ul>
            </section>

            <section className="policy-section">
              <h2>Sustainability Commitments</h2>
              <p>
                We are committed to reducing our environmental footprint by
                sourcing responsible materials, improving supply chain
                transparency, and prioritising circular initiatives. Discover
                our latest sustainability goals and progress on the Mangoes
                journey to a more mindful future.
              </p>
            </section>

            <section className="policy-section">
              <h2>Visit Us</h2>
              <p>
                Experience Mangoes in person at one of our flagship stores or
                explore the full collection online. Our teams are here to help
                with styling advice, fit questions, and personalised services.
              </p>
            </section>

            <div className="policy-actions">
              <button className="btn-primary" onClick={toTop}>
                Back to Top
              </button>
              <Link className="link-underline" to="/shop" onClick={toTop}>
                Continue Shopping
              </Link>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </body>
  );
}

export default About;
